
type TranslationFunction = (key: string) => string;

export const validateEmail = (email: string | undefined, t: TranslationFunction): string | null => {
    if (!email?.trim()) {
        return t("common:form.requiredFieldForm");
    }
    if (!email.includes("@")) {
        return t("common:genericFormErrors.RequiredFieldEmailForm");
    }
    return null; // No error
};

export const validatePhone = (phone: string | undefined, t: TranslationFunction): string | null => {
    if (!phone?.trim()) {
        return t("common:form.requiredFieldForm");
    }

    // Remove all non-digit characters to check if it's a valid phone number
    const phoneDigits = phone.replace(/\D/g, '');

    // Check if phone has at least 7 digits and at most 15 digits (international standard)
    if (phoneDigits.length < 7 || phoneDigits.length > 15) {
        return t("common:genericFormErrors.InvalidPhoneForm"); // You'll need to add this translation key
    }

    // Optional: More strict validation - check for common phone patterns
    // This regex allows: +1234567890, (123) 456-7890, 123-456-7890, 123.456.7890, 123 456 7890
    const phoneRegex = /^[+]?[\d\s\-().]{7,}$/;
    if (!phoneRegex.test(phone)) {
        return t("common:genericFormErrors.InvalidPhoneForm");
    }

    return null; // No error
};
